import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

// Visual "Join the list" form. Non-functional (Klaviyo embed to follow).
export const EmailCapture = ({ invert = false }) => {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    toast("You're on the list", {
      description: "We'll be in touch before the doors open.",
    });
    setEmail("");
  };

  const line = invert ? "border-cream text-cream placeholder:text-cream/40" : "border-ink text-ink placeholder:text-ink/40";

  return (
    <form onSubmit={submit} className="w-full max-w-xl" data-testid="email-capture-form">
      <div className={`flex items-center gap-4 border-b ${invert ? "border-cream" : "border-ink"} pb-3`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email"
          data-testid="email-input"
          className={`w-full rounded-none bg-transparent text-lg tracking-tight focus:outline-none md:text-2xl ${line}`}
        />
        <button
          type="submit"
          aria-label="Join the list"
          data-testid="email-submit"
          className={`shrink-0 transition-transform duration-300 hover:translate-x-1 ${
            invert ? "text-cream" : "text-ink"
          }`}
        >
          <ArrowRight className="h-7 w-7" />
        </button>
      </div>
    </form>
  );
};
